<template>
  <b-row class="justify-content-center" no-gutters>
    <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="fit-to-screen bg-white">
      <div class="w-100 bg-white fit-to-screen">
        <div class="w-100 py-5 px-4" v-if="cartContext.error != ''">
          <ErrorMessage :message="cartContext.error" />
        </div>
        <template v-else>
          <span id="top-section"></span>
          <!-- NAVBAR -->
          <div class="w-100 position-sticky bg-white border-form py-3 z-index-1041" style="top:0px;">
            <div class="ga-container py-2">
              <div class="d-flex">
                <div class="lh-1 align-self-center mr-3">
                  <svg @click="cartContext.goToPage('PosHome')" class="lh-1 cursor-pointer" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_581_18)">
                      <path
                        d="M0.0294189 8.00744C0.0294189 8.27112 0.145437 8.5137 0.356381 8.7141L7.35969 15.7069C7.57064 15.9073 7.79213 16.0022 8.04526 16.0022C8.56207 16.0022 8.97341 15.6225 8.97341 15.0951C8.97341 14.842 8.87848 14.5889 8.70973 14.4306L6.34717 12.0259L2.1705 8.21839L1.949 8.7352L5.34519 8.94614H18.6874C19.2358 8.94614 19.6155 8.5559 19.6155 8.00744C19.6155 7.45899 19.2358 7.06874 18.6874 7.06874H5.34519L1.949 7.27969L2.1705 7.80705L6.34717 3.98898L8.70973 1.58422C8.87848 1.41546 8.97341 1.17288 8.97341 0.919749C8.97341 0.392393 8.56207 0.0126953 8.04526 0.0126953C7.79213 0.0126953 7.57064 0.0970726 7.3386 0.32911L0.356381 7.30079C0.145437 7.50118 0.0294189 7.74376 0.0294189 8.00744Z"
                        fill="black" fill-opacity="0.85" />
                    </g>
                    <defs>
                      <clipPath id="clip0_581_18">
                        <rect width="19.5861" height="16" fill="white" transform="translate(0.0294189 0.0126953)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="lh-1 align-self-center">
                  <p class="body-1-4 mb-0">{{ cartContext.payment_in_page ? 'Payment' : 'Cart' }}</p>
                </div>
              </div>
            </div>
          </div>
          <block :height="10" />

          <template v-if="!cartContext.payment_in_page">
            <!-- ORDER SUMMARY -->
            <div class="ga-container">
              <p class="mb-4 body-1-4">Order Summary</p>
              <div class="mb-4">
                <div class="w-100" v-for="(product,product_i) in cartContext.getOutletTrxProducts" :key="product_i">
                  <ProductCart :data="product" :product_index="product_i" />
                </div>
              </div>

              <div class="w-100 border-orange p-3 radius-6" id="add_menu_section">
                <div class="row no-gutters">
                  <div class="col-9 align-self-center">
                    <div class="pr-3">
                      <p class="mb-0 body-2-1">Add more to your order?</p>
                      <p class="mb-0 body-3-3-1">Discover diverse and delicious options</p>
                    </div>
                  </div>
                  <div class="col-3 align-self-center">
                    <button class="g-btn g-btn-secondary g-btn-sm w-100" @click="cartContext.goToPage('PosHome')">Add More</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

            <!-- GUEST INFO -->
            <div class="ga-container">
              <p class="mb-0 body-1-4">Personalize Your Order, Note by Note!</p>
              <p class="mb-3 body-3-3-1">Add your name, table number, and special requests for a perfect meal!</p>
              <GuestForm ref="order_guest_form" type="ORDER" :is-contact-required="cartContext.need_guest_data_for_payment"  />
              <span id="middle_section"></span>
            </div>
            <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

            <template v-if="cartContext.general_data.use_delivery">
              <!-- SERVE OPTION -->
              <div class="ga-container">
                <p class="mb-0 body-1-4">Choose Your Dining Preference</p>
                <p class="mb-3 body-3-3-1">Indicate whether you prefer delivery or on-site dining.</p>
                <div class="w-100">
                  <div class="w-100 mb-3 radius-6 cursor-pointer position-relative" v-for="(serve,serve_i) in cartContext.serve_option.list" :key="serve.id" :id="serve.id" @click="cartContext.serveOptionSelect(serve)" :class="serve.id != cartContext.serve_option.selected.id ? 'border-form' : 'border-green'">
                    <div class="d-flex align-items-center py-2 z-index-1026">
                      <div class="px-3 text-center">
                        <svg v-if="serve.id != cartContext.serve_option.selected.id" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z"
                            fill="#222222" />
                        </svg>
                        <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" class="fill-primary"/>
                        </svg>
                      </div>
                      <div>
                        <div class="w-100 pr-3">
                          <p class="mb-0 body-2-1">{{ serve.title }}</p>
                          <p class="mb-0 body-3-3-1">{{ serve.subtitle }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="primary-overlay z-index-1025 radius-6" v-if="serve.id == cartContext.serve_option.selected.id"></div>
                  </div>
                </div>
              </div>
              <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

              <!-- DELIVERY INFORMATION -->
              <template v-if="cartContext.serve_option.selected.id == 'delivery'">
                <div class="ga-container">
                  <p class="mb-0 body-1-4">Ensure Your Order Reaches You!</p>
                  <p class="mb-3 body-3-3-1">Provide your delivery address for a seamless experience.</p>
                  <p class="mb-3 body-2 text-danger" v-if="cartContext.serve_option.error != ''">{{ cartContext.serve_option.error }}</p>
                  <Delivery ref="delivery_section" page_module="CUSTOM_POS" :pos_id="cartContext.general_data.id" />
                </div>
                <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
              </template>
            </template>

            <!-- PROMO CODE -->
            <div class="ga-container">
              <p class="mb-0 body-1-4">Apply Promo Code</p>
              <p class="mb-3 body-3-3-1">Enter your code to unlock special offers.</p>
              <PromoCode :general_data="cartContext.general_data" />
            </div>
            <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

            <!-- PRICE DETAIL -->
            <div class="ga-container">
              <p class="mb-0 body-1-4">Price Details</p>
              <p class="mb-3 body-3-3-1">Review the cost breakdown before finalizing.</p>
              <div class="row slim-grid-row mb-2">
                <div class="col-7 align-self-center">
                  <p class="mb-0 body-2-1">Subtotal</p>
                </div>
                <div class="col-5 text-right align-self-center">
                  <p class="mb-0 font-lato text-14">{{ $formatCurrency(cartContext.getOutletTrxSubTotal) }}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-2" v-if="cartContext.getOutletTrxTaxService > 0">
                <div class="col-7 align-self-center">
                  <p class="mb-0 body-2-1">Tax &amp; Service</p>
                </div>
                <div class="col-5 text-right align-self-center">
                  <p class="mb-0 font-lato text-14">{{ $formatCurrency(cartContext.getOutletTrxTaxService) }}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-2">
                <div class="col-6">
                  <p class="mb-0 body-2-1">Discount</p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 font-lato text-14" :class="{'text-green': cartContext.getOutletTrxPromotion > 0}">- {{ cartContext.getOutletTrxPromotion > 0 ? $formatCurrency(cartContext.getOutletTrxPromotion) : '' }}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-2" v-if="cartContext.getOutletTrxDelivery.use && cartContext.serve_option.selected.id == 'delivery'">
                <div class="col-7 align-self-center">
                  <p class="mb-0 body-2-1">Delivery Fee</p>
                </div>
                <div class="col-5 text-right align-self-center">
                  <p class="mb-0 font-lato text-14">{{ cartContext.getOutletTrxDelivery.inquiry.delivery_fee ?  $formatCurrency(cartContext.getOutletTrxDelivery.inquiry.delivery_fee) : '0' }}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-2" v-if="cartContext.payment_surcharge > 0">
                <div class="col-7 align-self-center">
                  <p class="mb-0 body-2-1">Payment Surcharge</p>
                </div>
                <div class="col-5 text-right align-self-center">
                  <p class="mb-0 font-lato text-14">{{ $formatCurrency(cartContext.payment_surcharge) }}</p>
                </div>
              </div>
              <div class="border-b-semi-grey-dashed-2 w-100 my-3"></div>
              <div class="row slim-grid-row" id="for-payment-section">
                <div class="col-6">
                  <p class="mb-0 body-1-4">Total</p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 font-lato text-16">{{ $formatCurrency(cartContext.total_price) }}</p>
                </div>
              </div>
            </div>
            <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

            <!-- PAYMENT -->
            <div class="ga-container" v-if="!cartContext.is_load">
              <template v-if="!cartContext.getOutletTrxDelivery.use">
                <p class="mb-0 body-1-4">{{ cartContext.paymentOptionText.title }}</p>
                <p class="mb-3 body-3-3-1">{{ cartContext.paymentOptionText.subtitle }}</p>
                <template v-if="cartContext.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER'">
                  <div class="w-100">
                    <div class="w-100 mb-3 radius-6 cursor-pointer position-relative" v-for="(p_mode,p_mode_i) in cartContext.payment_mode.list" :key="p_mode.id" :id="p_mode.id" @click="cartContext.paymentModeSelect(p_mode)" :class="p_mode.id != cartContext.payment_mode.data.id ? 'border-form' : 'border-green'">
                      <div class="row no-gutters align-items-center py-2 z-index-1026">
                        <div class="col-2 text-center">
                          <svg v-if="p_mode.id != cartContext.payment_mode.data.id" width="20" height="20" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z"
                              fill="#222222" />
                          </svg>
                          <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" class="fill-primary"/>
                          </svg>
                        </div>
                        <div class="col-10">
                          <div class="w-100 pr-3">
                            <p class="mb-0 body-2-1">{{ p_mode.title }}</p>
                            <p class="mb-0 body-3-3-1">{{ p_mode.description }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="primary-overlay z-index-1025 radius-6" v-if="p_mode.id == cartContext.payment_mode.data.id"></div>
                    </div>
                  </div>
                  <p class="mb-0 mt-2 body-2 text-danger" v-if="cartContext.validate_payment.mode">Please select payment option</p>
                </template>
              </template>
              <div class="w-100 mb-4" :class="{'mt-4 border-t-semi-grey-dashed-2' : !cartContext.getOutletTrxDelivery.use}" v-if="cartContext.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && cartContext.payment_mode.data.id == 'PAY_IMMEDIATELY'"></div>
              <div class="w-100" v-if="cartContext.general_data.payment_mode == 'PAY_IMMEDIATELY' || (cartContext.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && cartContext.payment_mode.data.id == 'PAY_IMMEDIATELY')">
                <p class="mb-0 body-1-4">{{ cartContext.paymentOptionText.title }}</p>
                <p class="mb-3 body-3-3-1">{{ cartContext.paymentOptionText.subtitle }}</p>
                <div class="w-100">
                  <PaymentMethod ref="payment_method" module="concierge" :sub_module="cartContext.general_data.code" @selectPayment="cartContext.selectPayment" @doneLoad="cartContext.paymentMethodDoneLoad"></PaymentMethod>
                </div>
              </div>
            </div>

            <!-- BUTTON -->
            <block :height="10" />
            <div class="w-100 position-sticky bg-white border-form py-3" style="bottom: 0px">
              <div class="ga-container">
                <div class="row slim-grid-row mb-2">
                  <div class="col-12 mb-2 text-center" v-if="cartContext.error_push != ''">
                    <p class="mb-0 body-2 text-danger">Error : {{ cartContext.error_push }}</p>
                  </div>
                  <div class="col-6">
                    <p class="mb-0 body-1-4">Total</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 font-lato text-16">{{ $formatCurrency(cartContext.total_price) }}</p>
                  </div>
                </div>
                <state-button variant="primary" size="xl" block :click="cartContext.submitForm">Place Order</state-button>
              </div>
            </div>
          </template>

          <div class="w-100 py-4 ga-container" id="payment_section" v-else>
            <XenditCardPayment
              :tx_payment="cartContext.tx_payment"
              module_page="CONCIERGE"
              submodule_page="CUSTOM_POS"
              @done="cartContext.clearCart"
              @expired="cartContext.goToHomepage">
            </XenditCardPayment>
          </div>
        </template>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  import ProductCart from '@/components/hotel/concierge/pos/ProductCart';
  import GuestForm from '@/components/hotel/concierge/pos/GuestForm';
  import PromoCode from '@/components/hotel/concierge/pos/PromoCode.vue';
  import PaymentMethod from '@/components/general/payment/PaymentMethod';
  import XenditCardPayment from '@/components/v2/XenditCardPayment';
  import Delivery from "@/components/general/Delivery";

  export default {
    components:{
      ProductCart,
      GuestForm,
      PromoCode,
      PaymentMethod,
      XenditCardPayment,
      Delivery
    },
    inject: ['cartContext'],
    methods: {
      validateOrderGuestForm() {
        return this.$refs.order_guest_form.validateForm()
      },
      toggleDelivery() {
        if (this.$refs.delivery_section) {
          this.$refs.delivery_section.toggleDelivery()
        }
      },
      validatePaymentMethod() {
        return this.$refs.payment_method.validateForm()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/layouts/CartMobileLayout.vue